import { render } from "./NavForPublic.vue?vue&type=template&id=0da2d32e&ts=true"
import script from "./NavForPublic.vue?vue&type=script&lang=ts"
export * from "./NavForPublic.vue?vue&type=script&lang=ts"

import "./NavForPublic.vue?vue&type=style&index=0&id=0da2d32e&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__